import { useCallback, useEffect, useState, useSyncExternalStore } from 'react'
import { bootstrapSession } from './api'
import { getSnapshot, setBootstrapped, subscribeSession } from './session'

export function useSession() {
  const snap = useSyncExternalStore(subscribeSession, getSnapshot, getSnapshot)
  return {
    user: snap.user,
    amr: snap.amr,
    sessionId: snap.sessionId,
    bootstrapped: snap.bootstrapped,
    hasStepUp: snap.hasStepUp,
    isAuthenticated: Boolean(snap.user && snap.user.id !== 'pending' && snap.accessToken),
  }
}

export function useSessionBootstrap() {
  const bootstrapped = useSyncExternalStore(
    subscribeSession,
    () => getSnapshot().bootstrapped,
    () => false,
  )
  const [error, setError] = useState<string | null>(null)

  const run = useCallback(async () => {
    setError(null)
    try {
      await bootstrapSession()
    } catch (e) {
      setError(e instanceof Error ? e.message : 'bootstrap_failed')
    } finally {
      setBootstrapped(true)
    }
  }, [])

  useEffect(() => {
    if (!bootstrapped) void run()
  }, [bootstrapped, run])

  return { bootstrapped, error, retry: run }
}
